import VGSidebar from "vgsidebar/app/js/app";

window.addEventListener('hashchange', (e) => {
	let hashStart = e.oldURL.indexOf('#');
	if (hashStart !== -1) {
		let hash = e.oldURL.substring(hashStart + 1);
		let element = document.getElementById(hash);

		if (
			e.newURL.indexOf(hash) === -1
			&& element?.classList?.contains('vg-sidebar')
		) {
			VGSidebar.getInstance(element)?.hide();
		}
	}
});
